import { ActivityDto } from '@ecdlink/core';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ContentActivityService } from '@services/ContentActivityService';
import { RootState, ThunkApiType } from '../../types';

export const ActivitiesActions = {
  GET_ACTIVITIES: 'getActivities',
};

export const getActivities = createAsyncThunk<
  ActivityDto[],
  { locale: string; overrideCache?: boolean },
  ThunkApiType<RootState>
>(
  ActivitiesActions.GET_ACTIVITIES,
  async ({ locale, overrideCache = false }, { getState, rejectWithValue }) => {
    const {
      auth: { userAuth },
      activityData: { activities: activitiesCache },
    } = getState();

    // === CACHE CHECK ===
    if (!overrideCache && activitiesCache && activitiesCache.length > 0) {
      return activitiesCache;
    }

    // === FETCH FROM API ===
    try {
      if (!userAuth?.auth_token) {
        return rejectWithValue('no access token, profile check required');
      }

      return await new ContentActivityService(
        userAuth?.auth_token
      ).getActivities(locale);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
